import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_16783_51629)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M9.99984 19.2936C14.6022 19.2936 18.3332 15.5627 18.3332 10.9603C18.3332 6.35791 14.6022 2.62695 9.99984 2.62695C5.39746 2.62695 1.6665 6.35791 1.6665 10.9603C1.6665 15.5627 5.39746 19.2936 9.99984 19.2936Z",
			stroke: "#004A96",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M10 5.96094V10.9609L13.3333 12.6276",
			stroke: "#004A96",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_16783_51629",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "translate(0 0.960938)"
		})
	}) })]
});
export default SvgHistory;
